export class SendSmsServiceConstants {
    // static readonly url = {
    //   postSmsUrl: "api/v2/Communication/GenerateSms"
    // }
    static COMPONENT_NAME = "Send SMS Service";
    static AD_HOC_COMMS = "AdHocComms";
}
